const TransactionHistory = () => import('./pages/TransactionHistory')
// const SenditTable = () => import('./pages/SenditTable')
const TableTeste = () => import('./pages/TableTeste')
const LogsTransactions = () => import('./pages/LogsTransactions.vue')

const transactionRoutes = [
  {
    path: 'transactions/history',
    name: 'TransactionsHistory',
    component: TransactionHistory,
    meta: { requiresAuth: true, menuType: 'transactions' },
  },
  {
    path: 'sendittable',
    name: 'TableTeste',
    component: TableTeste,
    meta: { requiresAuth: true, menuType: 'transactions' },
  },
]

export default transactionRoutes
